import HttpConstants from "./constants.js";

class ApiClient {

    constructor(
        host = null,
        scheme = HttpConstants.URL_SCHEME.HTTPS,
        token = null,
        unauthorizedHandler = null,
        headers = {
            'Accept': HttpConstants.MIME_TYPES.JSON_LD,
            'Content-Type': HttpConstants.MIME_TYPES.JSON_LD
        }
    ) {

        this._host = host;
        this._scheme = scheme;
        this._token = token;
        this._unauthorizedHandler = unauthorizedHandler;
        this._headers = headers;
        if (token !== null) {
            this._headers.Authorization = token;
        }
    }

    get getHost() { return this._host; }
    get getScheme() { return this._scheme; }
    get getToken() { return this._token; }

    get getUnauthorizedHandler() { return this._unauthorizedHandler; }

    set setUnauthorizedHandler(handler) {
        this._unauthorizedHandler = handler;
    }
    get getHeaders() { return this._headers; }

    set setHeaders(headers) { this._headers = headers; }

    addHeader(key, value) {
        this._headers[key] = value;
    }

    getUri(api) {
        if (this._host !== null) {
            return this._scheme + '://' + this._host + '/' + api;
        } else {
            return api;
        }
    }

    async fetch(api, method = HttpConstants.METHODS.GET, body = null, otherSettings= {}) {
        let sanitizedBody = null;

        if (method !== HttpConstants.METHODS.GET) {
            if (body !== null) {
                sanitizedBody = body;
            }
        }

        const defaultSettings = { method: method, headers: this._headers, body: sanitizedBody };
        const combinedSettings = {...defaultSettings, ...otherSettings};

        const response = await fetch(this.getUri(api), combinedSettings);
        return this.handleResponse(response);
    }

    async handleResponse(response) {
        if (response.status === 401) {
            if (this._unauthorizedHandler) {
                await this._unauthorizedHandler();
            }
        }
        return response;
    }

}

const makeApiClient = (options = {}) => {
    return new ApiClient(
        options['host']?? undefined,
        options['scheme']?? undefined,
        options['token']?? undefined,
        options['unauthorizedHandler']?? undefined,
        options['headers']?? undefined
    );
};

export { ApiClient, makeApiClient, HttpConstants };